var StateDestinationFactory = function ($q, $http) {
    var factory = {};

    factory.determineNextState = function (flowName) {
        var deferred = $q.defer();

        $http
            .get(
                // eslint-disable-next-line no-undef
                __authenticationUrl__ + "rest/partialauth/state/getNextUserState/" + flowName
            )
            .success(function (data) {
                deferred.resolve(data);
            })
            .error(function (data) {
                // TODO: Use logger to log the error message

                deferred.reject(data);
            });

        return deferred.promise;
    };

    factory.getParticipantDataAsync = function () {
        var deferred = $q.defer();
        $http
            .get(
                // eslint-disable-next-line no-undef
                __authenticationUrl__ +
                    "rest/partialauth/retirementIncomeView/participantLoginInformation"
            )
            .success(function (data) {
                deferred.resolve(data);
            })
            .error(function (data) {
                // TODO: Use logger to log the error message

                deferred.reject(data);
            });
        return deferred.promise;
    };

    factory.determineNextDest = function (flowName) {
        var deferred = $q.defer();

        $http
            .get(
                // eslint-disable-next-line no-undef
                __baseApiUrl__ +
                    "/participant-web-services/rest/partialauth/dest/getNextAuthDestination/" +
                    flowName
            )
            .success(function (data) {
                deferred.resolve(data);
            })
            .error(function (data) {
                // TODO: Use logger to log the error message

                deferred.reject(data);
            });

        return deferred.promise;
    };

    factory.getInBoundUser = function () {
        var deferred = $q.defer();

        $http
            // eslint-disable-next-line no-undef
            .get(__authenticationUrl__ + "rest/nonauth/getInBoundUser")
            .success(function (data) {
                deferred.resolve(data);
            })
            .error(function (data) {
                // TODO: Use logger to log the error message

                deferred.reject(data);
            });

        return deferred.promise;
    };

    return factory;
};

StateDestinationFactory.$inject = ["$q", "$http"];
export default StateDestinationFactory;
